import { RevealOnView } from "@/components/Reveal";
import { AXIOM } from "@/constants/testIds";

const WHY = [
  {
    n: "W/01",
    title: "Complex engineering, solved.",
    body: "First-principles work on problems that require deep technical expertise and years of product development experience.",
  },
  {
    n: "W/02",
    title: "End-to-end product development.",
    body: "Concept, simulation, prototyping, manufacturing and production support - under one accountable roof.",
  },
  {
    n: "W/03",
    title: "Lean R&D. No overhead.",
    body: "A dedicated engineering team on-demand. Accelerate development, reduce technical risk, ship faster.",
  },
  {
    n: "W/04",
    title: "Built in India. Ready for the world.",
    body: "Headquartered in Mumbai with a network of specialist partners - delivering world-class engineering out of India.",
  },
];

export default function WhyUs() {
  return (
    <section data-testid={AXIOM.whyus} className="bg-panel py-24 md:py-32 border-t border-rule">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6">
          <RevealOnView className="col-span-12 md:col-span-4">
            <div className="eyebrow mb-4">Why AxiomForge</div>
            <h2
              className="font-display text-ink"
              style={{ fontSize: "clamp(30px, 4vw, 46px)", lineHeight: 1.05, letterSpacing: "-0.02em" }}
            >
              A partner, <span className="text-forge">not a vendor.</span>
            </h2>
            <p className="text-ink/70 mt-6 max-w-[42ch]" style={{ fontSize: "16px", lineHeight: 1.6 }}>
              We embed as an extension of your engineering team. Same standards.
              Same accountability. Better outcomes.
            </p>
          </RevealOnView>
          <div className="col-span-12 md:col-span-8 grid grid-cols-1 md:grid-cols-2">
            {WHY.map((w, i) => (
              <RevealOnView key={w.n} delay={i * 0.05}>
                <div className={`p-8 md:p-10 border-t border-rule ${i % 2 === 0 ? "md:border-r md:border-rule" : ""}`}>
                  <div className="font-mono text-[11px] tracking-[0.14em] text-forge uppercase">{w.n}</div>
                  <h3
                    className="font-display text-ink mt-4"
                    style={{ fontSize: "24px", lineHeight: 1.15, letterSpacing: "-0.02em" }}
                  >
                    {w.title}
                  </h3>
                  <p className="text-ink/70 mt-3 max-w-[40ch]" style={{ fontSize: "15px", lineHeight: 1.6 }}>
                    {w.body}
                  </p>
                </div>
              </RevealOnView>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
